
import { defineComponent } from 'vue';
import { postWebV1UpdateConfigPageApi } from '@/api/manage-app/app-update-record';
import {
  postWebV1UpdateConfigPageApiResListResItem,
  PostWebV1UpdateConfigPageApiReq,
} from '@/api/manage-app/app-update-record/index.d';
import { useList } from '@/hooks/use-list';
import { useAppList } from '@/views/app/app-manage/composables/useAppList';
import { APP_SYSTEM_TYPE_LIST, APP_UPDATE_LEVEL_LIST } from '@/constant';

export default defineComponent({
  name: 'AppUpdateRecord',
  setup() {
    const {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<postWebV1UpdateConfigPageApiResListResItem, PostWebV1UpdateConfigPageApiReq>({
      request: {
        api: postWebV1UpdateConfigPageApi,
        params: {
          appPlatform: '',
          appName: '',
          updateLevel: '',
          versionNum: '',
          creatorName: '',
          pageNum: 1,
          pageSize: 10,
        },
      },
    });
    handleSearch();
    const { appList } = useAppList({
      type: 'all',
    });

    return {
      tableData,
      params,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      APP_SYSTEM_TYPE_LIST,
      APP_UPDATE_LEVEL_LIST,
      appList,
    };
  },
});
